/** Screen C — entry confirmation / receipt (`/e/:entryId`), §4.2 C. The URL carries only the entry id. */
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../lazy';

const ReceiptPage = lazyRoute(() => import('./ReceiptPage'));

export const receiptRoutes: RouteObject[] = [{ path: '/e/:entryId', element: <ReceiptPage /> }];
